// Curated "stitched for real customers" photos shown in the builder's
// social-proof strip. These are customers' own 5-star Loox review photos
// (the same images the PDP review widget serves, from Loox's CDN), hand
// picked for clearly visible embroidery. Refresh occasionally: pull
// candidates with rk-loox's reviews_client, eyeball, swap URLs here.

export type StitchedExample = { img: string; caption: string };

export const STITCHED_EXAMPLES: StitchedExample[] = [
  {
    img: "https://images.loox.io/uploads/2025/10/20/55xn7sPdA_orig.jpg",
    caption: "Matching cat portraits on heavyweight hoodies",
  },
  {
    img: "https://images.loox.io/uploads/2025/6/19/bPdIisJKd_orig.jpg",
    caption: "Penny the pom on a quarter zip",
  },
  {
    img: "https://images.loox.io/uploads/2025/9/25/FLE4NILSC_orig.jpg",
    caption: "Family line drawing in tonal thread",
  },
  {
    img: "https://images.loox.io/uploads/2025/5/17/Q05x33mLG_orig.jpg",
    caption: "Their first car, stitched on a crewneck",
  },
  {
    img: "https://images.loox.io/uploads/2025/12/27/j0iJAhRFO_orig.jpg",
    caption: "Lorna and Dolly, coloured + filled",
  },
  {
    img: "https://images.loox.io/uploads/2023/10/3/DzaC9li4h_orig.jpg",
    caption: "A kid's drawing, stitched for dad",
  },
  {
    img: "https://images.loox.io/uploads/2025/1/23/FuroKgkoL_orig.jpg",
    caption: "Love from Wes",
  },
];
